import { render, staticRenderFns } from "./inspection-contact.vue?vue&type=template&id=3b462b61"
import script from "./inspection-contact.vue?vue&type=script&lang=js"
export * from "./inspection-contact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports